import { fail, success } from '@helpers/result-helper.js'
import toast from '@services/toasts/index.js'
import { isHttpStatus, isSuccess } from '@/helpers/http-status-helpers'
import { VuexResponse } from '@/helpers/vuex-action-builder'
import WorkplaceRegisterExportFailureToasts from '@/shared/constants/workplaceRegister/WorkplaceRegisterExportFailureToasts'

export default {
  namespaced: true,
  state: {
    canListLoadingCount: 0,
    loadingCount: 0,
    crudLoadingCount: 0,
    file: null,
    candidateList: [],
  },
  getters: {
    moduleName: () => 'candidate',
    isCanListLoading: (state) => state.canListLoadingCount > 0,
    isLoading: (state) => state.loadingCount > 0,
    isLoadingCRUD: (state) => state.crudLoadingCount > 0,
    candidateList: (state) => state.candidateList,
  },
  mutations: {
    START_LOADING(state) {
      state.loadingCount++
    },
    START_CANLIST_LOADING(state) {
      state.canListLoadingCount++
    },
    FINISH_LOADING(state) {
      state.loadingCount--
    },
    FINISH_CANLIST_LOADING(state) {
      state.canListLoadingCount--
    },
    START_LOADING_CRUD(state) {
      state.crudLoadingCount++
    },
    FINISH_LOADING_CRUD(state) {
      state.crudLoadingCount--
    },
    SET_CANDIDATE_LIST(state, data) {
      state.candidateList = data
    },
  },
  actions: {
    async loadCandidate({ commit }, id) {
      commit('START_LOADING')
      try {
        const response = await this.$api.candidate.getCandidateDetails(id)

        if (isSuccess(response.status)) {
          return success(response.data)
        }
      } catch {
        toast.error('Candidate data failed to load')
        return fail()
      } finally {
        commit('FINISH_LOADING')
      }
    },

    async getCandidateListByClientIds({ commit }, clientIds = []) {
      commit('START_CANLIST_LOADING')
      try {
        const response = await this.$api.candidate.getCandidateListByClientIds(
          clientIds
        )

        if (isSuccess(response.status)) {
          const list = response?.data?.candidates || []
          commit('SET_CANDIDATE_LIST', list)
          return success(list)
        }
      } catch (ex) {
        if (isHttpStatus(ex.response.status, 'Forbidden')) {
          return fail([], '', 403)
        }

        toast.error(this.$i18n.t('candidateList.candidateListErrorCannotLoad'))
        return fail()
      } finally {
        commit('FINISH_CANLIST_LOADING')
      }
    },

    async getCandidates({ commit }, payload) {
      return await new VuexResponse(commit)
        .request(() => this.$api.candidate.getCandidates(payload))
        .go()
    },

    async exportCandidates(
      { commit },
      { locationIds, startDate, endDate, format, useACECQATemplate }
    ) {
      const { data, statusCode } = await new VuexResponse(commit)
        .request(() =>
          this.$api.candidate.exportCandidates(
            locationIds,
            startDate,
            endDate,
            format,
            useACECQATemplate
          )
        )
        .withSuccessToast(this.$i18n.t('candidateExport.exportSuccessText'))
        .go()

      if (data) return data

      toast.error(
        this.$i18n.t(
          WorkplaceRegisterExportFailureToasts[statusCode.toString()] ||
            'candidateExport.errors.generic'
        )
      )

      return null
    },
  },
}
